import { render, staticRenderFns } from "./DisputesAdmin.vue?vue&type=template&id=11f6bb80&"
import script from "./DisputesAdmin.vue?vue&type=script&lang=js&"
export * from "./DisputesAdmin.vue?vue&type=script&lang=js&"
import style0 from "./DisputesAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports